import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const ConfirmMail = lazy(() => import("../views/dashboard/auth/confirm-mail"));
const LockScreen = lazy(() => import("../views/dashboard/auth/lock-screen"));
const Recoverpw = lazy(() => import("../views/dashboard/auth/recoverpw"));
const SignIn = lazy(() => import("../views/dashboard/auth/sign-in"));
const SignUp = lazy(() => import("../views/dashboard/auth/sign-up"));
const Error404 = lazy(() => import("../views/dashboard/errors/error404"));
const Error500 = lazy(() => import("../views/dashboard/errors/error500"));
const Maintenance = lazy(() => import("../views/dashboard/errors/maintenance"));

export const SimpleRouter = [
  {
    path: "default/auth/sign-in",
    element: (
      <Suspense fallback={<Backdrop />}>
        <SignIn />
      </Suspense>
    ),
  },
  {
    path: "default/auth/sign-up",
    element: (
      <Suspense fallback={<Backdrop />}>
        <SignUp />
      </Suspense>
    ),
  },

  {
    path: "default/auth/confirm-mail",
    element: (
      <Suspense fallback={<Backdrop />}>
        <ConfirmMail />
      </Suspense>
    ),
  },
  {
    path: "default/auth/lock-screen",
    element: (
      <Suspense fallback={<Backdrop />}>
        <LockScreen />
      </Suspense>
    ),
  },
  {
    path: "default/auth/recoverpw",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Recoverpw />
      </Suspense>
    ),
  },
  {
    path: "errors/error404",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Error404 />
      </Suspense>
    ),
  },
  {
    path: "errors/error500",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Error500 />
      </Suspense>
    ),
  },
  {
    path: "errors/maintenance",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Maintenance />
      </Suspense>
    ),
  },
];
